import { SemanticMetadata, TimeUnit } from 'routes/secondary-market-batch/grid/types';
import { levelPriority } from 'routes/secondary-market-batch/grid/utils/get-higher-level';
import { ApiLevel } from 'utils/http/httpClient.model';

const MONTHS_IN_QUARTER = 3;

function toDurationLike(unit: TimeUnit, amount: number): Temporal.DurationLike {
  switch (unit) {
    case 'Nanosecond':
      return { nanoseconds: amount };
    case 'Microsecond':
      return { microseconds: amount };
    case 'Millisecond':
      return { milliseconds: amount };
    case 'Second':
      return { seconds: amount };
    case 'Minute':
      return { minutes: amount };
    case 'Hour':
      return { hours: amount };
    case 'Day':
      return { days: amount };
    case 'Week':
      return { weeks: amount };
    case 'Month':
      return { months: amount };
    case 'Quarter':
      return { months: amount * MONTHS_IN_QUARTER };
    case 'Year':
      return { years: amount };
  }
}

export function getSemanticBoundaryLevel(
  boundaries: SemanticMetadata,
  targetDatetime: string,
  now: Temporal.ZonedDateTime,
): ApiLevel | undefined {
  const target = Temporal.Instant.from(targetDatetime).toZonedDateTimeISO(now.timeZoneId);
  return boundaries
    .filter(({ unit, start, end }) => {
      const windowStart = target.add(toDurationLike(unit, start));
      const windowEnd = target.add(toDurationLike(unit, end));
      const isInRange =
        Temporal.ZonedDateTime.compare(now, windowStart) >= 0 && Temporal.ZonedDateTime.compare(now, windowEnd) < 0;
      return isInRange;
    })
    .map(({ level }) => level)
    .sort((a, b) => levelPriority[b] - levelPriority[a])[0];
}
